<template>
  <div>
    <div id="graficoConvenios"></div>
  </div>
</template>

<script>
  import Highcharts from 'highcharts'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'Charts-Convenios',
    mounted () {
      this.dataSource()
    },
    computed: {
      ...mapGetters('schedule', ['getList', 'getAvailableAppointments', 'getAppointments'])
    },
    props: ['categories', 'value'],
    watch: {
      getList () {
        this.dataSource()
      }
    },
    methods: {
      dataSource () {
        const convenios = !this.getList ? [] : this.getList.map(item => item.convenantDesc)
        const data = convenios.filter(function (element) {
          return element !== undefined
        })
        const base = _(data)
          .countBy()
          .map((value, key) => ({ key, value }))
          .orderBy(['value'], ['desc'])
          .value()
        const categories = base.map(item => item.key)
        const values = base.map(item => item.value)
        this.setup({ categories, values })
      },
      setup (obj) {
        const { categories, values } = obj
        Highcharts.chart('graficoConvenios', {
          chart: {
            type: 'column'
          },
          title: {
            text: 'Convênios'
          },
          subtitle: {
            text: 'Fonte: Risc Sistemas em Saúde'
          },
          xAxis: {
            categories: categories,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: ''
            }
          },
          series: [{
            name: 'Quantidade',
            data: values

          }]
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/schedule/AgreementColumn.vue